import React, { useContext } from 'react';
import { PageStateContext } from '../../services';
import { AnyProps } from '../types';

export const RocheTrainingMaterial = ({ blok, slot }: AnyProps): JSX.Element => {
  const pageContext = useContext(PageStateContext);
  const URL = blok?.order_form_url.story ? `/${blok?.order_form_url?.story.url}` : blok?.order_form_url?.url;

  return (
    <roche-training-material
      headline={blok.headline}
      introtext={blok.intro_text}
      fieldlabel={blok.field_label}
      buttonlabel={blok.button_label}
      filterstitle={blok.filters_title}
      allproductslabel={blok.all_products_label}
      placeholderlabel={blok.placeholder_label}
      products={JSON.stringify(pageContext?.products)}
      order-link-label={blok.order_link_label}
      order-url={URL}
      slot={slot}
    >
    </roche-training-material>
  );
};
